export function norm2digit(numb: number = 0): string {
  return numb.toLocaleString('en-US', { minimumIntegerDigits: 2 });
}

export function splitByLastFourDigits(value: string | number) {
  const strValue = String(value);
  return [
    parseInt(strValue.slice(0, -4)),
    parseInt(strValue.slice(-4)),
  ].map(n => (isNaN(n) ? null : n));
}
